/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum EntityTreeDisplayModeEnum {
    EDIT = 'EDIT',
    VIEW = 'VIEW'
}
